import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Image from 'next/image';
import { useDispatch, useSelector } from 'react-redux';
import { autoPlay } from 'react-swipeable-views-utils';
import SwipeableViews from 'react-swipeable-views';

import { closeModal } from 'features/utilsSlice';
import useModalOpen from 'hooks/useModalOpen';
import TransitionDialog from 'components/TransitionDialog';
import BottomButtons from 'components/BottomButtons';
import SwitchButton from 'components/SwitchButton';
import styles from 'styles/components/SignaturePreview.module.scss';

const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

const DialogContent = ({ handleClick, handleClose }) => {
  const [value, setValue] = useState(0);
  const images = useSelector(state => state.utils.modalData['Signature Preview']?.images);

  const handleChangeIndex = index => setValue(index);

  if (!images) return null;

  return (
    <div className={styles.container}>
      <div className={styles.imageContainer}>
        <AutoPlaySwipeableViews onChangeIndex={handleChangeIndex} index={value}>
          {[...images].map((image, index) => (
            <img
              key={index}
              src={image}
              width="100%"
              height="auto"
              style={{ objectFit: 'cover', zIndex: 1, height: 415 }}
              alt="Media"
            />
          ))}
        </AutoPlaySwipeableViews>

        <SwitchButton assets={images} value={value} setValue={setValue} />
      </div>

      <div className={styles.content}>
        <h1>Look okay?</h1>
        <h4 style={{ fontSize: 16, marginBottom: 20 }}>
          Please make sure that your photo meets our requirements. It should be:
        </h4>
        <span>Clear (not blurry)</span>
        <span>Bold black on a white background</span>
        <span>Full screen (no paper edges visible)</span>
      </div>

      <BottomButtons
        text="Retake"
        textContained="Use"
        handleClose={handleClose}
        handleClick={handleClick}
        fixed
      />
    </div>
  );
};

const CameraSignaturePreview = ({ openInventory, ...props }) => {
  const dispatch = useDispatch();
  const open = useModalOpen('Signature Preview');

  const handleClose = (_, reason) => {
    if (reason === 'backdropClick') return;
    dispatch(closeModal('Signature Preview'));
  };

  const handleClick = () => {
    dispatch(closeModal('Signature Preview'));
    dispatch(closeModal('Signature Camera'));
    openInventory();
  };

  return (
    <TransitionDialog open={open} handleClose={handleClose} noCloseIcon>
      <DialogContent {...props} handleClose={handleClose} handleClick={handleClick} />
    </TransitionDialog>
  );
};

DialogContent.propTypes = {
  handleClick: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
};

DialogContent.defaultProps = {
  disabled: false,
};

export default CameraSignaturePreview;
